export default "__VITE_ASSET__CoA7gYIw__"